<template>
	<div>
		<div v-if="!mode"> 
			<div style="display: flex">
				<b-button
					v-b-toggle="className"
					block
					class="panel-item-header-button"
				>
					<div style="display: flex">
						<span class="panel-item-header-trigger-icon" />
						<span class="panel-item-header-title">
							<h5> {{ displayDataEdit.name || 'No company name' }} </h5>
							<span class="when-open"> <br> <br> </span>
							<span class="when-closed">
								<b> Industry </b>
								<br>
								{{ displayDataEdit.industry || 'No industry' }}
							</span> 
						</span>
					</div>
				</b-button>
				<img v-if="displayDataEdit.logoUrl" :src="imageUrl" height="150px">
				<div v-if="!displayDataEdit.logoUrl" class="empty-image" />
			</div>

			<b-collapse :id="className">
				<b-container>
					<b-row> 
						<b-col>
							<b> Industry </b>
						</b-col>
						<b-col>
							<b> Relationship </b>
						</b-col>
					</b-row>
					<b-row> 
						<b-col>
							{{ displayDataEdit.industry || 'No industry' }}
						</b-col>
						<b-col>
							{{ displayDataEdit.relationship }}
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>

					<b-row>
						<b-col>
							<b> Links </b>
						</b-col>
					</b-row>
					<b-row v-for="(link, number) in displayDataEdit.link" :key="number">
						<b-col> 
							<b-icon icon="link45deg" />
							<a :href="link.url"> {{ link.name }} </a>
						</b-col>
					</b-row>
					<b-row v-if="!displayDataEdit.link || displayDataEdit.link.length === 0">
						<b-col> 
							No links
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>

					<b-row>
						<b-col>
							<b> Address </b>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<pre>{{ address }}</pre>
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>

					<b-row v-if="displayDataEdit.relationship === 'Owner'">
						<b-col>
							<h5> Ownership Stake </h5>
						</b-col>
					</b-row>

					<b-row v-if="displayDataEdit.relationship === 'Owner'">
						<b-col>
							<div>
								<div> 
									<b> Ownership % </b>
								</div>
								<div style="text-align: right">
									<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
									{{ displayDataEdit.ownershipPct }}%
								</div>
							</div>
						</b-col>
					</b-row>

					<b-row v-if="displayDataEdit.relationship === 'Owner'">
						<b-col>
							<div>
								<div> 
									<b> Total Investment </b>
								</div>
								<div style="text-align: right">
									<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
									${{ displayDataEdit.totalInvestment }}
								</div>
							</div>
						</b-col>
					</b-row>

					<b-row v-if="displayDataEdit.relationship === 'Owner'">
						<b-col>
							<div>
								<div> 
									<b> Total Paid Out </b>
								</div>
								<div style="text-align: right">
									<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
									${{ displayDataEdit.totalPaidOut }}
								</div>
							</div>
						</b-col>
					</b-row>

					<b-row v-if="displayDataEdit.relationship !== 'Owner'">
						<b-col>
							<h5> Service Agreements </h5>
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>
					
					<div v-if="displayDataEdit.relationship !== 'Owner'">
						<b-row v-for="(agreement, no) in displayDataEdit.serviceagreements" :key="agreement.id">
							<b-col>
								<service-agreement-view
									:index="no"
									:agreement="agreement"
									:mode="mode"
									class="service-agreement-view"
								/>
								<div v-if="index !== displayDataEdit.serviceagreements.length" style="height: 15px;" />
							</b-col>
						</b-row>
					</div>
				</b-container>
			</b-collapse>
		</div>
		<div v-if="mode">
			<b-container>
				<b-row> 
					<b-col>
						<label for="input-name">Name</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-name"
							v-model="displayDataEdit.name"
							size="sm"
							placeholder="Enter your name"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-logoUrl">Logo URL</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<image-upload-input :image-url="displayDataEdit.logoUrl ? displayDataEdit.logoUrl : ''" @update-image="updateImage" />
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-industry">Industry</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-industry"
							v-model="displayDataEdit.industry"
							size="sm"
							placeholder="Enter the industry"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-relationship">Relationship to Asset</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-select
							id="input-relationship"
							v-model="displayDataEdit.relationship"
							:options="options"
							size="sm"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<h5 style="margin-top: 1rem;">
							Address
						</h5>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-addressLine1">Address 1</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-addressLine1"
							v-model="displayDataEdit.addressLine1"
							size="sm"
							placeholder="Enter the address line 1"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-addressLine1">Address 2</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-addressLine2"
							v-model="displayDataEdit.addressLine2"
							size="sm"
							placeholder="Enter the address line 2"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-city">City</label>
					</b-col>
					<b-col>
						<label for="input-county">County</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-city"
							v-model="displayDataEdit.city"
							size="sm"
							placeholder="Enter the city"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-county"
							v-model="displayDataEdit.county"
							size="sm"
							placeholder="Enter the county"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-state">State</label>
					</b-col>
					<b-col>
						<label for="input-postalCode">Postal Code</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-city"
							v-model="displayDataEdit.state"
							size="sm"
							placeholder="Enter the state"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-postalCode"
							v-model="displayDataEdit.postalCode"
							size="sm"
							placeholder="Enter the postal code"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-country">Country</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-country"
							v-model="displayDataEdit.country"
							size="sm"
							placeholder="Enter the country"
						/>
					</b-col>
				</b-row>

				<link-input
					v-for="(link, id) in displayDataEdit.link"
					:key="id"
					:link="link"
					:index="id"
					@update-link="updateLink"
					@remove-link="removeLink"
				/>

				<b-row v-if="!displayDataEdit.link || displayDataEdit.link.length === 0"> 
					<b-col>
						<label for="input-link">Link</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-button block @click="addLink()">
							Add a Link
						</b-button>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>
					
				<b-row v-if="displayDataEdit.relationship === 'Owner'"> 
					<b-col>
						<h5>Ownership</h5>
					</b-col>
					<b-col>
						<b-form-datepicker
							id="datepicker"
							v-model="displayDataEdit.asOfDate"
							size="sm" 
							locale="en" 
							placeholder="Choose a date"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row v-if="displayDataEdit.relationship === 'Owner'"> 
					<b-col>
						<label for="input-ownership">Ownership %</label>
					</b-col>
					<b-col>
						<label for="input-investment">Total Investment ($)</label>
					</b-col>
				</b-row>

				<b-row v-if="displayDataEdit.relationship === 'Owner'"> 
					<b-col>
						<b-form-input
							id="input-ownership"
							v-model="displayDataEdit.ownershipPct"
							size="sm"
							type="number"
							placeholder="Enter the ownership %"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-investment"
							v-model="displayDataEdit.totalInvestment"
							size="sm"
							type="number"
							placeholder="Enter the total investment"
						/>
					</b-col>
				</b-row>

				<b-row v-if="displayDataEdit.relationship === 'Owner'"> 
					<b-col>
						<label for="input-totalpaidout">Total Paid Out ($)</label>
						<b-form-input
							id="input-totalpaidout"
							v-model="displayDataEdit.totalPaidOut"
							size="sm"
							type="number"
							placeholder="Enter the total paid out"
						/>
					</b-col>
				</b-row>

				<b-row v-if="displayDataEdit.relationship === 'Owner'">
					<b-col style="height: 15px" />
				</b-row>

				<div v-if="displayDataEdit.relationship !== 'Owner'">
					<b-row v-for="(agreement, agreementIndex) in displayDataEdit.serviceagreements" :key="agreement.id">
						<b-col>
							<service-agreement-view
								:index="agreementIndex"
								:agreement="agreement"
								:mode="mode"
								class="service-agreement-view"
							/>
							<div v-if="index !== displayDataEdit.serviceagreements.length" style="height: 15px;" />
						</b-col>
					</b-row>
				</div>

				<b-row v-if="displayDataEdit.relationship !== 'Owner'"> 
					<b-col>
						<b-button block @click="addServiceAgreement()">
							Add Service Agreement
						</b-button>
					</b-col>
				</b-row>

				<b-row v-if="displayDataEdit.relationship !== 'Owner'">
					<b-col style="height: 15px" />
				</b-row>

				<b-row> 
					<b-col>
						<b-button block style="background-color: #FFAAAA; color: #000000;" @click="remove()">
							Remove Company
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
import ServiceAgreementView from './ServiceAgreementView.vue';
import LinkInput from './LinkInput.vue';
import ImageUploadInput from './ImageUploadInput.vue';

export default {
    name: 'CompanyView',
	components: { ServiceAgreementView, LinkInput, ImageUploadInput },
    filters: {},
	props: {
        company: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true
        },
		mode: {
			type: Boolean,
			required: false
		}
	},   
    data() {
        return {
            className: '',
			displayDataEdit: {},
			address: '',
			options: [
				{ value: 'Owner', text: 'Owner' },
				{ value: 'Service Provider', text: 'Service Provider' }
			],
			newLink: { name: '', url: '' },
			imageUrl: ''
        }
    },
	watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.address = this.formatAddress(this.displayDataEdit);
				this.updateData();
			},
		},
		company: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		},
        index: {
			immediate: true,
			handler(newVal) {
				this.className = `collapse_${newVal}`;
			},
		}
	},
	async created() {
		if (this.company.logoUrl && this.company.logoUrl !== '') this.imageUrl = await this.getImage(this.company.logoUrl)
	},
    methods: {
		formatAddress(displayDataEdit) {
			let firstLine = ''; 
			let secondLine = '';
			let formatedAddress = '';
			// first line
			if (displayDataEdit.addressLine1 !== null && displayDataEdit.addressLine1 !== '') {
				firstLine = displayDataEdit.addressLine1
			}
			if (!displayDataEdit.addressLine2 !== null && displayDataEdit.addressLine2 !== '') {
				if (firstLine !== '') firstLine += ', '
				firstLine += displayDataEdit.addressLine2
			}
			// second line
			if (displayDataEdit.city !== null && displayDataEdit.city !== '') {
				secondLine = displayDataEdit.city
			}
			if (displayDataEdit.county !== null && displayDataEdit.county !== '') {
				if (secondLine !== '') secondLine += ', '
				secondLine += displayDataEdit.county
			}
			if (displayDataEdit.state !== null && displayDataEdit.state !== '') {
				if (secondLine !== '') secondLine += ', '
				secondLine += displayDataEdit.state
			}
			if (displayDataEdit.postalCode !== null && displayDataEdit.postalCode !== '') {
				if (secondLine !== '') secondLine += ', '
				secondLine += displayDataEdit.postalCode
			}
			// third line
			if (displayDataEdit.country === null || displayDataEdit.country === ''){
				if (firstLine !== '' && secondLine !== '') {
					formatedAddress = `${firstLine } \n`
					formatedAddress += `${secondLine }`
				} else if (firstLine !== '') {
					formatedAddress = `${firstLine }`
				} else if (secondLine !== '')  {
					formatedAddress = `${secondLine }`
				}
			} else if (firstLine !== '' && secondLine !== '') {
				formatedAddress = `${firstLine } \n`
				formatedAddress += `${secondLine } \n`
				formatedAddress += `${displayDataEdit.country }`
			} else if (firstLine !== '') {
				formatedAddress = `${firstLine } \n`
				formatedAddress += `${displayDataEdit.country }`
			} else if (secondLine !== '') {
				formatedAddress = `${secondLine } \n`
				formatedAddress += `${displayDataEdit.country }`
			} else {
				formatedAddress = displayDataEdit.country
			}
			if (formatedAddress === '') {
				formatedAddress = 'No address'
			}
			return formatedAddress;
		},
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postAssetCompanyModelData = await this.axios.patch(
					`/assetcompanies/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
			if (this.displayDataEdit.logoUrl && this.displayDataEdit.logoUrl !== '') this.imageUrl = await this.getImage(this.displayDataEdit.logoUrl)
		},
		async remove() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const deleteAssetCompanyModelData = await this.axios.delete(
					`/assetcompanies/${this.displayDataEdit.id}`
				);
				this.$emit('remove');
			}
		},
		addLink() {
			try {
				this.displayDataEdit.link.push(this.newLink);
				this.newLink = { name: '', url: '' };
			} catch (error) {
				this.$bvToast.toast(`${error.message}`, {
					title: `Bad Entry`,
					autoHideDelay: 5000,
					appendToast: false,
					variant: 'danger',
				});
			}
		},
		updateLink(data) {
			this.displayDataEdit.link[data.index] = data.link;
		},
		removeLink(index) {
			this.displayDataEdit.link.splice(index, 1);
		},
		async addServiceAgreement() {
			const newServiceAgreement = {
				service: "",
				startDate: null,
				endDate: null,
				totalValue: 0,
				associatedPhases: [],
				notes: "",
				assetcompanyId: this.displayDataEdit.id
			}
			const postServiceAgreementModelData = await this.axios.post(
				`/serviceagreements`,
				newServiceAgreement
			);
			this.displayDataEdit.serviceagreements.push(postServiceAgreementModelData.data);
		},
		async getImage(uri) {
			let image = '';
			if (uri.match(/^http.*/)) image = uri;
			if (uri.match(/^\/files\/*/)) {
				try {
					const img = await this.axios.get(`${uri}`, { responseType: 'blob' })
					image = URL.createObjectURL(img.data)
				} catch (error) {
					/* */
				}
				
			}			
			return image;
		},
		updateImage(data) {
			this.displayDataEdit.logoUrl = data;
		},
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
	width: 50%;
    background-color: transparent;
}
.panel-item-header-title {
    bottom: 2px;
}
div.service-agreement-view {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #e4e4e4;
}
div.empty-image {
	height: 150px;
    border-radius: 12px;
    margin: 12px;
	background-color: #d0d0d0;
}
.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
</style>

<style lang="scss">
</style>